import { takeLatest, call, put } from "redux-saga/effects"
import axios from "axios"
import { message } from "antd"
import { push } from "connected-react-router"

import {
  GET_RECIPIENTS_SUMMARY_WATCHER,
  UPLOAD_TEMPLATE_RECIPIENTS_WATCHER,
  SAVE_EXCEL_RECIPIENTS_WATCHER,
} from "./constants"

import {
  getRecipientsSummarySuccess,
  getRecipientsSummaryFailed,
  uploadTemplateRecipientsFailed,
  uploadTemplateRecipientsSuccess,
  saveExcelRecipientsProgress,
  saveExcelRecipientsSuccess,
} from "./actions"
import { LOCAL_TOKEN } from "../../utils/storage"

function messageProgress(messagex) {
  message.loading(messagex, 0)
}

function messageSuccess(messagex) {
  message.success(messagex, 5)
}

function messageFailed(messagex) {
  message.error(messagex, 5)
}

function messageDestroy() {
  message.destroy()
}

// GET SUMMARY
function getRecipientsSummaryApi(payload) {
  const measureId = localStorage.getItem("currentMeasure")
  const token = LOCAL_TOKEN()
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${token}` },
    url: `${process.env.API_URL}measure/${measureId}/recipients/import/xlsx/summary`,
    params: payload,
  })
}

function* getRecipientsSummary() {
  try {
    const search = window.location.search
    const queryParams = new URLSearchParams(search)

    let timestamp = {
      timestamp: queryParams.get("time"),
    }
    const { data, status } = yield call(getRecipientsSummaryApi, timestamp)
    if (status === 200) yield put(getRecipientsSummarySuccess(data[0]))
  } catch (error) {
    yield put(getRecipientsSummaryFailed())
  }
}

// UPLOAD EXCEL
function uploadTemplateRecipients(payload) {
  const measureId = localStorage.getItem("currentMeasure")
  const token = LOCAL_TOKEN()
  return axios.request({
    method: "post",
    url: `${process.env.API_URL}measure/${measureId}/recipients/import/xlsx`,
    headers: { Authorization: `Bearer ${token}` },
    data: payload,
  })
}

function uploadTemplateRecipientsProgress(payload) {
  const measureId = localStorage.getItem("currentMeasure")
  const token = LOCAL_TOKEN()
  return axios.request({
    method: "get",
    url: `${process.env.API_URL}measure/${measureId}/recipients/import/xlsx/progress`,
    headers: { Authorization: `Bearer ${token}` },
    params: payload,
    validateStatus: (status) => true, // I'm always returning true,
  })
}

export function* uploadTemplateRecipientsWatcher(action) {
  try {
    yield call(messageProgress, "Cargando archivo")
    const uploadData = yield call(uploadTemplateRecipients, action.payload)
    const measureId = localStorage.getItem("currentMeasure")
    let timestamp = { timestamp: uploadData.data.timestamp }
    let data
    while (true) {
      yield new Promise((resolve) => setTimeout(resolve, 1000))
      data = yield call(uploadTemplateRecipientsProgress, timestamp)
      if (data.status === 200) {
        yield call(messageDestroy)
        yield put(
          push(
            `/models/measure/${measureId}/import-recipients/summary?time=${timestamp.timestamp}`
          )
        )
        yield call(getRecipientsSummary)
        yield call(messageSuccess, "Archivo importado")
        yield put(uploadTemplateRecipientsSuccess(data.data))
        break
      }
      if (data.status === 500 || data.status === 400 || data.status === 404) {
        yield call(messageDestroy)
        yield call(messageFailed, data.data.data.error.status)
        yield put(uploadTemplateRecipientsFailed())
        break
      }
    }
  } catch (error) {
    yield put(uploadTemplateRecipientsFailed())
    yield call(messageDestroy)
    yield call(messageFailed, "Error al importar archivo")
  }
}

// SAVE EXCEL
function saveExcelRecipientsApi(payload) {
  const measureId = localStorage.getItem("currentMeasure")
  const token = LOCAL_TOKEN()
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${token}` },
    url: `${process.env.API_URL}measure/${measureId}/recipients/import/xlsx/confirm`,
    params: payload,
    validateStatus: (status) => true,
  })
}

function saveExcelRecipientsProgressApi(payload) {
  const measureId = localStorage.getItem("currentMeasure")
  const token = LOCAL_TOKEN()
  return axios.request({
    method: "get",
    url: `${process.env.API_URL}measure/${measureId}/recipients/import/xlsx/confirm/progress`,
    headers: { Authorization: `Bearer ${token}` },
    params: payload,
    validateStatus: (status) => true,
  })
}

export function* saveExcelRecipientsSaga(action) {
  try {
    const search = window.location.search
    const queryParams = new URLSearchParams(search)

    let timestamp = {
      timestamp: queryParams.get("time"),
    }
    yield call(saveExcelRecipientsApi, timestamp)
    let data
    while (true) {
      yield new Promise((resolve) => setTimeout(resolve, 200))
      data = yield call(saveExcelRecipientsProgressApi, timestamp)
      if (data.status === 202) {
        yield put(
          saveExcelRecipientsProgress(data.data.data.result[0].percentage)
        )
      }
      if (data.status === 200) {
        yield put(saveExcelRecipientsProgress(100))
        yield put(saveExcelRecipientsSuccess(data))
        break
      }
    }
  } catch (error) {
    returnMessage(error)
  }
}

// Individual exports for testing
export default function* recipientsSummarySaga() {
  yield takeLatest(SAVE_EXCEL_RECIPIENTS_WATCHER, saveExcelRecipientsSaga)
  yield takeLatest(GET_RECIPIENTS_SUMMARY_WATCHER, getRecipientsSummary)
  yield takeLatest(
    UPLOAD_TEMPLATE_RECIPIENTS_WATCHER,
    uploadTemplateRecipientsWatcher
  )
}
